// @styles
require('./settingsView.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @components
import { OKCover } from 'commonsComponents/OKCover';
import OKHeaderLanding from 'components/commons/OKHeaderLanding/OKHeaderLanding';
import { LoadingSection } from 'commonsComponents/loadingSection';
import TutorialLauncher from 'components/tutorial/tutorialLauncher';
import { CommercialAds } from 'components/commons/commercialAds/commercialAds';
import { ConfirmModal } from 'components/commons/confirmModal/confirmModal';
import AggregatorTinkInfoSettings from 'components/aggregator/tink/aggregatorTinkInfoSettings/aggregatorTinkInfoSettings';
import { AggregatorTinkManageEntities } from './components/aggregatorTinkManageEntities/aggregatorTinkManageEntities';

// @actions
import {
  removeEntityTink,
  toggleActiveTink,
  getSecondFactorAuth,
  getGlobalPositionTink,
} from 'actions/aggregator/aggregatorData';

// @utilities
import { getAggregatorDataAllProductsByBankTink } from 'selectors/aggregator';
const { formatText } = require('core/i18n').i18n;

// @constants
const { GRAPHIC_TUTOR_TYPE_10 } = require('constants/index');
const TRANSLATION_KEY_PREFIX = 'aggregatorManageEntities';
const titleKey = TRANSLATION_KEY_PREFIX + '-headerTitle';

class SettingsViewClass extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dirty: false,
      openModal: false,
      userBankId: null,
    };
  }

  componentWillMount() {
    this.props.getGlobalPositionTink();
  }

  componentDidUpdate(prevProps, prevState) {
    const { dirty } = prevState;

    const { getGlobalPositionTink } = this.props;
    if (this.state.dirty === true && this.state.dirty !== dirty) {
      getGlobalPositionTink();
      this.setState({ dirty: false });
    }
  }

  componentWillUnmount() {
    const { dirty } = this.state;
    const { getGlobalPositionTink } = this.props;
    if (!__CONTACT_CENTER__ && dirty) getGlobalPositionTink();
  }

  handleOnDirty = () => {
    this.setState({ dirty: true });
  };

  showModal = userBankId => {
    this.setState({
      openModal: true,
      userBankId: userBankId,
    });
  };

  handleOnAcceptRemoveEntity = () => {
    const { userBankId } = this.state;
    const { removeEntityTink } = this.props;

    removeEntityTink(userBankId);
    this.setState({
      openModal: false,
      userBankId: null,
    });
  };

  handleOnCancelRemoveEntity = () => {
    this.setState({
      openModal: false,
      userBankId: null,
    });
  };

  renderSidebar = () => {
    return (
      <div className="aggregator-manage-entities__info grid-view--variable-cell-separation">
        <AggregatorTinkInfoSettings />
        <div className="aggregator-manage-entities__info__commercial">
          <CommercialAds path="global/entities/manage" type="banner-a" />
        </div>
      </div>
    );
  };

  renderContent = () => {
    const { aggregatorData, toggleActiveTink, isFetching, getSecondFactorAuth } = this.props;

    const onRequestPool = aggregatorData.getIn(['data', 'isOnRequestPool']);
    const hasBanks = Object.keys(aggregatorData.toJS().data.banks).length > 0;

    const productsByBank = (hasBanks &&
      getAggregatorDataAllProductsByBankTink(aggregatorData.toJS().data)) || { size: 0 };

    if (!onRequestPool && this.state.dirty && (isFetching || !hasBanks)) return <LoadingSection />;

    return (
      <AggregatorTinkManageEntities
        onHandleDirty={this.handleOnDirty}
        productsByBank={productsByBank}
        removeEntity={this.showModal}
        toggleActive={toggleActiveTink}
        getSecondFactorAuth={getSecondFactorAuth}
        isTinkAggregator={true}
      />
    );
  };

  render() {
    const tutorial = (
      <TutorialLauncher
        type={GRAPHIC_TUTOR_TYPE_10}
        title={formatText('tutorials-aggregatorManageEntitiesViewTitle')}
        subtitle={formatText('tutorials-aggregatorManageEntitiesViewSubtitle')}
        tooltip={formatText('tutorials-aggregatorManageEntitiesViewTooltip')}
      />
    );

    const mappingBreadcrumb = [
      {
        text: formatText('breadcrumb-global'),
        url: '/myprofile/global',
      },
      {
        text: formatText(titleKey),
        url: '',
      },
    ];

    return (
      <div>
        <ConfirmModal
          open={this.state.openModal}
          title={formatText(`${TRANSLATION_KEY_PREFIX}-modalTitle`)}
          text={formatText(`${TRANSLATION_KEY_PREFIX}-modalText`)}
          onAccept={this.handleOnAcceptRemoveEntity}
          onCancel={this.handleOnCancelRemoveEntity}
        />
        <div className="container-fluid">
          <div className="row">
            <OKCover size="small" section="pg" customClass="col-xs-12">
              <OKHeaderLanding
                title={formatText(titleKey)}
                tutorial={tutorial}
                breadcrumbConfig={mappingBreadcrumb}
                inputClassName="ok-header-landing--aggregator-settings"
              />
            </OKCover>
          </div>
        </div>
        <div className="grid-view__body">
          <div className="container-fluid">
            <div className="row aggregator-manage-entities">
              <div className="col-xs-12 col-md-8">{this.renderContent()}</div>
              <div className="col-xs-12 col-md-4">{this.renderSidebar()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SettingsViewClass.propTypes = {
  aggregatorData: PropTypes.object,
  removeEntityTink: PropTypes.func,
  toggleActiveTink: PropTypes.func,
  isFetching: PropTypes.bool,
  getSecondFactorAuth: PropTypes.func,
  getGlobalPositionTink: PropTypes.func,
};

const SettingsView = connect(
  state => {
    return {
      aggregatorData: state.aggregatorData,
      isFetching: state.aggregatorData.get('isFetching'),
    };
  },
  {
    removeEntityTink,
    toggleActiveTink,
    getSecondFactorAuth,
    getGlobalPositionTink,
  }
)(SettingsViewClass);

export { SettingsView };
